<template>
  <div class="step">
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my?active=我的报名' }"
        >我的报名</el-breadcrumb-item
      >
      <el-breadcrumb-item>报名查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <!-- 公共内容 -->
      <Process></Process>
      <!-- 右边内容 -->
      <el-col :span="18" class="conter">
        <h2>
          {{ info.companies.name}}
          <p></p>
        </h2>
        <ul class="step_ul">
          <dd v-for="item in list" :key="item.id">
            <li v-if="item.is_show == 1" @click="ToStep(item.code)">
              {{ item.name }}
            </li>
            <li v-if="item.is_show == 0" class="disabled">{{ item.name }}</li>
          </dd>
          <!--          <li @click="ToCertificate">证书查询</li>-->
        </ul>
      </el-col>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      list: [],
      info: {
        companies:{
          name:"",
        }
      },
      post_id: 0,

    };
  },
  computed: {},
  created() {
    var query = this.$route.query;
    this.post_id = query.post_id;
    this.getStep(this.post_id);},
  mounted() {
  },
  watch: {},
  methods: {
    ToStep(code) {
      if (code == 101) {
        this.$router.push("/examine?post_id=" + this.post_id);
      }
      if (code == 102) {
        this.$router.push("/enroll_Printing?post_id=" + this.post_id);
      }
      if (code == 103) {
        this.$router.push("/Winterview?post_id=" + this.post_id);
      }
      if (code == 104) {
        this.$router.push("/report?iswritten=1&post_id=" + this.post_id);
      }
      if (code == 105) {
        this.$router.push("/interview?post_id=" + this.post_id);
      }
      if (code == 106) {
        this.$router.push("/report?post_id=" + this.post_id);
      }
      if (code == 107) {
        this.$router.push("/payment?type=1&post_id=" + this.post_id);
      }
      if (code == 108) {
        this.$router.push("/payment?type=2&post_id=" + this.post_id);
      }
    },
    // ToCertificate() {
    //   this.$router.push("/certificate");
    // },

    getStep(id) {
      let _this = this;
      _this
        .request("api/post_up_success", { post_id: id }, "get")
        .then((res) => {
          if (res.data.status == "success") {
            this.list = res.data.data.list;
            this.info = res.data.data.info;
            console.log(this.list, this.info);
          }
        });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
</script>

<style lang="less" scoped>
.step {
  .tac {
    .conter {
      h2 {
        font-size: 0.5rem;
        color: #00a0e9;
        text-align: center;
      }
      .step_ul {
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 1rem;
        li {
          width: 4.9rem;
          height: 0.72rem;
          border-radius: 0.1rem;
          background-color: #00a0e9;
          margin: 0.95rem auto;
          text-align: center;
          line-height: 0.72rem;
          font-size: 0.37rem;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
.disabled {
  background: #ccc !important;
}
</style>
